var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M50 0H0v32.333h27.586v10.08l11.298-10.08H50z"}})}
var staticRenderFns = []

export { render, staticRenderFns }